import { FieldType, ProductOrganizationDialogConfig, ProductOrganizationTableTemplate } from '../../product.model';

export const cardsDialogConfig: ProductOrganizationDialogConfig = {
	title: 'Karty produktowe',
	configType: 'cards',
	fields: [
		{ key: 'url', label: 'Url', type: FieldType.TEXT, required: true, placeholder: 'https://example.com' },
		{ key: 'note', label: 'Notatka', type: FieldType.TEXTAREA },
	],
};

export const cardsTableTemplate: ProductOrganizationTableTemplate[] = [
	...cardsDialogConfig.fields.map((field) => ({
		key: field.key,
		label: field.label,
	})),
	{ key: 'createdBy', label: 'Utworzone przez' },
	{ key: 'createdAt', label: 'Utworzone' },
	{ key: 'edit', label: '' },
];
